import { deleteCookie, getCookie, setCookie } from "cookies-next";
import { getRandom } from "./varities";
import { CookieKeys } from "@/constants/cookiesEnums";

const storeCookei = (key: string, value: string, age: number = 30) => {
  setCookie(key, value, {
    path: "/",
    maxAge: 60 * 60 * 24 * age,
  });
};
//============== branch id ================
export const storeBranchIdCookie = (branchId: number) => {
  storeCookei(CookieKeys.branch_id, branchId?.toString());
};
export const getBranchIdCookie = () =>
  (getCookie(CookieKeys.branch_id) as string) ?? null;
export const deleteBranchIdCookie = () => deleteCookie(CookieKeys.branch_id);
// ==================== Agent-id =======================

export const getAgentIdCookie = () => {
  const currentAgentId = getCookie(CookieKeys.agent_id) as string;
  if (currentAgentId) {
    storeCookei(CookieKeys.agent_id, currentAgentId);
    return currentAgentId;
  }
  const agentId = getRandom();
  storeCookei(CookieKeys.agent_id, agentId);
  return agentId;
};
//============== language ================
export const storeLangCookie = (lang: string) => {
  storeCookei(CookieKeys.language, lang);
};
export const getLangCookie = () => {
  const lang = getCookie(CookieKeys.language) as "en" | "ar";
  return lang;
};

//============== currency ================

export const storeCurrencyCookie = (currencyCode: string) => {
  storeCookei(CookieKeys.currency_code, currencyCode);
};
export const getCurrencyIdCookie = () => {
  const currency = getCookie(CookieKeys.currency_code);
  return currency;
};
//============== Tokens ================
export const storeAccessToken = (accessToken: string) => {
  storeCookei(CookieKeys.access_token, accessToken, 30);
};
export const storeAuthTokens = (accessToken: string, refreshToken: string) => {
  storeCookei(CookieKeys.access_token, accessToken, 30);
  storeCookei(CookieKeys.refresh_token, refreshToken, 30);
};
export const deleteTokens = () => {
  deleteCookie(CookieKeys.access_token);
  deleteCookie(CookieKeys.refresh_token);
};
export const getAccessToken = () => getCookie(CookieKeys.access_token);
export const getRefreshToken = () => getCookie(CookieKeys.refresh_token);
//====================================
export const getIPCookie = ()=>getCookie(CookieKeys.ip)